import { useEffect, useState } from "react";
import {
  onSnapshot,
  collection,
  query,
  orderBy,
  where,
} from "firebase/firestore";
import { database } from "../../database/firebase";

const useUserId = (userId) => {
  const [userRooms, setUserRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getUserRooms = async () => {
      try {
        setLoading(true);
        await onSnapshot(
          query(
            collection(database, "userRooms"),
            where("createdUserId", "==", userId),
            orderBy("timestamp", "desc")
          ),
          (snapshot) => {
            setUserRooms(
              snapshot.docs.map((doc) => ({
                data: doc.data(),
                id: doc.id,
              }))
            );
          }
        );

        setLoading(false);
      } catch (error) {
        setError(error.message);
      }
    };

    getUserRooms();
  }, [userId]);

  return [userRooms, loading, error];
};

export default useUserId;
